var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlatActionButton',{attrs:{"action":_vm.openModal,"buttonClass":['btnDefault'],"text":'View Reply Attributes'}})
}
var staticRenderFns = []

export { render, staticRenderFns }